import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { Status } from '../../../../../../shared/builds/types';
import { DependencyFilterKeys } from '../../../../../../shared/dependenciesV2';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import FilterCardCheckboxes from '../../../../generic/Filter/FilterCardCheckboxes';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import type { Status as StatusFilterOptions } from '../../../../../../shared/builds/types';
import type { SelectOption } from '../../../../../types';

// Filter labels by key value
const FILTER_LABELS: Record<StatusFilterOptions, string> = {
  [Status.Analyzed]: 'Analyzed',
  [Status.InProgress]: 'In Progress',
  [Status.Failed]: 'Failed',
  [Status.Unknown]: 'Unknown',
};

// Built filter options for checkbox filter
const FILTER_OPTIONS: SelectOption[] = Object.entries(FILTER_LABELS).map(([value, label]) => ({
  label, value,
}));

/**
 * Status filter which allows the user to filter dependencies by status.
 * Uses StatusFilterOptions to generate the checkbox filter values.
 */
const StatusFilter: VoidFunctionComponent = () => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const selectedOptions = (filters.status ?? []).map((option: StatusFilterOptions) => ({
    label: FILTER_LABELS[option],
    value: option,
  }));

  const onChange = (selected: SelectOption[]) => setFilter({
    ...filters,
    [DependencyFilterKeys.Status]: selected.map((option) => option.value),
  });

  return (
    <FilterCardCheckboxes
      label="Status"
      options={FILTER_OPTIONS}
      values={selectedOptions}
      onChange={onChange}
    />
  );
};

export default StatusFilter;
